import type { FileMapDataSubcategory, FileMapDataSubcategoryStyleLegend } from '../types'
import { layers_radinfra_width } from './layers/radinfra_width'
import { withBikelaneVisualLineOffset } from './layers/utils/bikelaneLineOffset'
import { wrapSourceLayers } from './layers/utils/wrapSourceLayers'

const subcatId = 'bikelanes'
const source = 'atlas_bikelanes'
const sourceLayer = 'bikelanes'

export const bikelanesWidthLegend: FileMapDataSubcategoryStyleLegend[] = [
  {
    id: 'below1m',
    name: '< 1,0 m',
    style: {
      type: 'line',
      color: '#ef9043',
    },
  },
  {
    id: '1to16m',
    name: '1,0–1.6 m',
    style: {
      type: 'line',
      color: '#f6de09',
    },
  },
  {
    id: '165-24m',
    name: '1,6–2.2 m',
    style: {
      type: 'line',
      color: '#a1e217',
    },
  },
  {
    id: 'above24',
    name: '≥ 2.2 m',
    style: {
      type: 'line',
      color: '#15c65c',
    },
  },
  {
    id: 'missing',
    name: 'Breite fehlt',
    style: {
      type: 'line',
      color: '#fda5e4',
      dasharray: [3, 2],
      width: 2,
    },
  },
]

export const subcat_radinfra_width: FileMapDataSubcategory = {
  id: subcatId,
  name: 'RVA Breite',
  ui: 'checkbox',
  sourceId: source,
  styles: [
    {
      id: 'default',
      name: 'RVA Breite', // field hidden
      layers: wrapSourceLayers({
        layers: withBikelaneVisualLineOffset(layers_radinfra_width),
        source,
        sourceLayer,
      }),
      legends: bikelanesWidthLegend,
    },
  ],
}
